(() => {
  const initialize = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.pickerReady === 'true') return;
    root.dataset.pickerReady = 'true';

    const context = root.dataset.pickerContext || 'inquiry';
    const cards = Array.from(root.querySelectorAll('[data-machine-value]'));
    const hidden = root.querySelector('[data-machine-picker-hidden]');
    let target = null;

    if (context === 'rfq') target = root.closest('[data-route-group="machine_quote"]')?.querySelector('[data-machine-family]');
    if (context === 'global-rfq') target = root.closest('form')?.querySelector('[data-machine-family]');
    if (context === 'project') target = root.closest('[data-project-group="machine"]')?.querySelector('[data-project-field="machine"]');

    const cardValue = (card) => context === 'project' ? card.dataset.projectValue : card.dataset.machineValue;
    const sync = (value) => {
      let selectedCard = null;
      cards.forEach((card) => {
        const selected = cardValue(card) === value;
        card.setAttribute('aria-pressed', String(selected));
        if (selected) selectedCard = card;
      });
      if (hidden instanceof HTMLInputElement) {
        hidden.value = selectedCard?.dataset.label || selectedCard?.dataset.machineValue || '';
      }
    };
    const currentValue = () => target instanceof HTMLSelectElement ? target.value : hidden?.value || '';

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        const value = cardValue(card) || '';
        if (target instanceof HTMLSelectElement) {
          const valid = Array.from(target.options).some((option) => option.value === value || option.textContent.trim() === value);
          if (valid) {
            const option = Array.from(target.options).find((item) => item.value === value || item.textContent.trim() === value);
            target.value = option?.value || value;
            target.dispatchEvent(new Event('input', { bubbles: true }));
            target.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        if (hidden instanceof HTMLInputElement) {
          hidden.value = card.dataset.label || card.dataset.machineValue || '';
          hidden.dispatchEvent(new Event('change', { bubbles: true }));
        }
        sync(value);
      });
    });

    if (target instanceof HTMLSelectElement) target.addEventListener('change', () => sync(target.value));
    sync(currentValue());
    window.setTimeout(() => sync(currentValue()), 250);
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-machine-family-picker]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();